import React from 'react';
import Pricing from '../components/pricing';

function PricingPage() {
  return <Pricing />;
}

export default PricingPage;
